import { render, staticRenderFns } from "./GerenciaVentas.vue?vue&type=template&id=68be1660&scoped=true"
import script from "./GerenciaVentas.vue?vue&type=script&lang=js"
export * from "./GerenciaVentas.vue?vue&type=script&lang=js"
import style0 from "./GerenciaVentas.vue?vue&type=style&index=0&id=68be1660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be1660",
  null
  
)

export default component.exports